import { FormGroup, Select, Text } from '@ksyos/design-system';
import type { IOption } from '@frontend/components/interfaces';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils/getValidationErrorTranslation';

interface AccountRequestSelectApproverProps {
    approverOptions: IOption<string>[];
    errors?: ValidationErrors;
    label?: string;
    onChange: (approverId: string) => void;
    organizationId: string;
    selectedApproverId: string | null;
    showHelpText?: boolean;
}

export function AccountRequestSelectApprover(props: Readonly<AccountRequestSelectApproverProps>) {
    const language = getSelectedLanguage();

    return (
        <FormGroup
            hasErrors={props.errors?.has('approverPractitionerId') ?? false}
            isRequired={true}
            label={props.label ?? language.accountRequest.approverPractitioner}
        >
            <>
                {props.showHelpText && (
                    <Text
                        color="subtle"
                        mb={1}
                        size="sm"
                    >
                        {language.accountRequest.approverPractitionerDescription}
                    </Text>
                )}
                <Select
                    error={getValidationErrorTranslation(props.errors?.get('approverPractitionerId')) ?? undefined}
                    onChange={(option) => {
                        props.onChange((option as IOption<string>).value);
                    }}
                    options={props.approverOptions}
                    placeholder=""
                    value={props.approverOptions.find((option) => option.value === props.selectedApproverId) ?? null}
                />
            </>
        </FormGroup>
    );
}
